import { render, staticRenderFns } from "./trDetail.vue?vue&type=template&id=74d0adc8&scoped=true"
import script from "./trDetail.vue?vue&type=script&lang=js"
export * from "./trDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0adc8",
  null
  
)

export default component.exports